import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiBase } from "../Reviews/api";
import "./public.css";
export default function PublicNotice({ kind }: { kind: string }) {
  const [notice, setNotice] = useState<any>(null),
    [error, setError] = useState(false),
    [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const c = new AbortController();
    setError(false);
    setNotice(null);
    fetch(`${apiBase}/api/beta/notices/${kind}`, { signal: c.signal })
      .then(r => {
        if (!r.ok) throw Error("Unavailable");
        return r.json();
      })
      .then(setNotice)
      .catch(() => {
        if (!c.signal.aborted) setError(true);
      });
    return () => c.abort();
  }, [kind, attempt]);
  return (
    <main className="public-notice">
      <Link to="/">← Reviewed home</Link>
      {error ? (
        <div role="alert">
          <p>We couldn’t load this notice. Please retry before continuing.</p>
          <button
            className="btn btn-primary"
            onClick={() => setAttempt(a => a + 1)}
          >
            Retry
          </button>
        </div>
      ) : notice ? (
        <>
          <p className="public-kicker">APPROVAL-ONLY TEST BETA</p>
          <h1>{notice.title}</h1>
          <p>{notice.text}</p>
          <small>Version: {notice.version}</small>
          <nav aria-label="Beta notices">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/beta">Beta scope</Link>
            <Link to="/privilege">Confidentiality</Link>
          </nav>
        </>
      ) : (
        <p role="status">Loading notice…</p>
      )}
    </main>
  );
}
